import { FastFilter } from '@vlabs/uikit';

import { withPopover } from '@vlabs/monokit/shared/ui/popovers/withPopover';

// eslint-disable-next-line import-x/no-namespace
import * as Popovers from './popovers';

const withBottomPopover = withPopover({ placement: 'bottom-start' });
const withFastBottomPopover = withBottomPopover(FastFilter);

export const DateFilterWithBottomPopover = withFastBottomPopover(Popovers.DateFilterPopover);
export const SourceFilterWithBottomPopover = withFastBottomPopover(Popovers.SourceFilterPopover);
export const HandlersFilterWithBottomPopover = withFastBottomPopover(Popovers.HandlersFilterPopover);
export const ListsFilterWithBottomPopover = withFastBottomPopover(Popovers.ListsFilterPopover);
export const PermissionTagsFilterWithBottomPopover = withFastBottomPopover(Popovers.PermissionTagsFilterPopover);
export const EventIdFilterWithBottomPopover = withFastBottomPopover(Popovers.EventIdFilterPopover);
export const CardIdFilterWithBottomPopover = withFastBottomPopover(Popovers.CardIdFilterPopover);
export const TopSimilarCardIdsFilterWithBottomPopover = withFastBottomPopover(
  Popovers.TopSimilarCardIdsFilterPopover,
);
export const ComparingAttributeFilterWithBottomPopover = withFastBottomPopover(
  Popovers.ComparingAttributeFilterPopover,
);
export const SimilarityFilterWithBottomPopover = withFastBottomPopover(Popovers.SimilarityFilterPopover);
export const TopSimilarObjectsFilterWithBottomPopover = withFastBottomPopover(Popovers.TopSimilarObjectsFilterPopover);
export const GenderFilterWithBottomPopover = withFastBottomPopover(Popovers.GenderFilterPopover);
export const AgeFilterWithBottomPopover = withFastBottomPopover(Popovers.AgeFilterPopover);
export const EmotionsFilterWithBottomPopover = withFastBottomPopover(Popovers.EmotionsFilterPopover);
export const MaskFilterWithBottomPopover = withFastBottomPopover(Popovers.MaskFilterPopover);
export const LivenessFilterWithBottomPopover = withFastBottomPopover(Popovers.LivenessFilterPopover);
export const DeepfakeFilterWithBottomPopover = withFastBottomPopover(Popovers.DeepfakeFilterPopover);
export const FaceIdFilterWithBottomPopover = withFastBottomPopover(Popovers.FaceIdFilterPopover);
export const ApparentGenderFilterWithBottomPopover = withFastBottomPopover(Popovers.ApparentGenderFilterPopover);
export const ApparentAgeFilterWithBottomPopover = withFastBottomPopover(Popovers.ApparentAgeFilterPopover);
export const UpperAttributesFilterWithBottomPopover = withFastBottomPopover(Popovers.UpperAttributesFilterPopover);
export const LowerAttributesFilterWithBottomPopover = withFastBottomPopover(Popovers.LowerAttributesFilterPopover);
export const ShoesColorFilterWithBottomPopover = withFastBottomPopover(Popovers.ShoesColorFilterPopover);
export const HeadwearFilterWithBottomPopover = withFastBottomPopover(Popovers.HeadwearFilterPopover);
export const BackpackFilterWithBottomPopover = withFastBottomPopover(Popovers.BackpackFilterPopover);
export const LocationFilterWithBottomPopover = withFastBottomPopover(Popovers.LocationFilterPopover);
export const TrackIdFilterWithBottomPopover = withFastBottomPopover(Popovers.TrackIdFilterPopover);
export const MetaFilterWithBottomPopover = withFastBottomPopover(Popovers.MetaFilterPopover);
